module.exports = __webpack_public_path__ + "static/media/fb.7a9e27bd.svg";